import createFieldArray from './createFieldArray';
import plain from './structure/plain';

export default createFieldArray(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/FieldArray.js
// module id = 1493
// module chunks = 0